/* eslint-disable class-methods-use-this */
const BASE_URL = 'https://tweetsy-backend.herokuapp.com/';
// const BASE_URL_NEW = "https://tweetsy-schl.herokuapp.com/"
const BASE_URL_NEW = 'https://www.tweetsy-backend.com/';
// const NODE_BASE_URL = "https://tweetsy-node.herokuapp.com/"
const NODE_BASE_URL = 'https://node.tweetsy-backend.com/';
// const NODE_BASE_URL = 'http://localhost:5000/';
// const NODE_BASE_URL = 'https://node-newauth.herokuapp.com/';

class TweetsyConfig {
    geturl() {
        // return BASE_URL;
        // changing the url for all at a time
        return BASE_URL_NEW;
    }

    geturlnew() {
        return BASE_URL_NEW;
    }

    getNodeUrl() {
        return NODE_BASE_URL;
    }

    tweetPerPage = 30;
}

export default new TweetsyConfig();
